import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
// import { useTranslation } from 'react-i18next';
import { useAsyncDebounce } from 'react-table';
import { StyledSearchInput } from '../../components/assets/StyledSearchInput';
export default function GlobalFilter({ preGlobalFilteredRows, setGlobalFilter, style, }) {
    // const { t } = useTranslation();
    // const count = preGlobalFilteredRows.length;
    const [value, setValue] = React.useState('');
    const onChange = useAsyncDebounce((value) => {
        setGlobalFilter(value || undefined);
    }, 300);
    return (_jsx(StyledSearchInput, { style: style, value: value || '', onChange: (e) => {
            setValue(e.target.value);
            onChange(e.target.value);
        }, placeholder: "Rechercher" }));
}
//# sourceMappingURL=GlobalFilter.js.map